<template>
  <custom-popup
    v-model="dialog"
    :cons="cons"
    max-width="640"
    @close="
      () => {
        name = icon = '';
      }
    "
  >
    <div v-if="dialog" class="pa-4">
      <v-text-field
        v-model="name"
        append-icon="mdi-text"
        clear-icon="mdi-close-circle-outline"
        clearable
        dense
        hide-details
        :label="$t('category_name')"
        outlined
      />

      <pic-selector
        :edit-img="false"
        :edit-name="false"
        :field.sync="icon"
        :default-cat-name="$t('TITLES.ADMIN_CATEGORY')"
        one-pic
        single
      />
    </div>
  </custom-popup>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import { mapState } from "vuex";

export default {
  name: "addCustomCategory",

  components: { PicSelector },

  props: {
    value: Boolean,
  },

  data() {
    return {
      name: "",
      icon: "",
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    ...mapState("local", ["qr_id"]),
    cons() {
      return {
        title: this.$t("add_subcategory"),
        buttons: [{ type: "submit", handler: this.addNewCat }],
      };
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addNewCat() {
      let cat = {
        source_id: null,
        status: "active",
        name: this.name,
        picture: this.icon,
        qr_id: this.qr_id,
        products: [],
      };

      this.name = this.icon = "";

      this.$emit("submit", cat);
    },
  },
};
</script>

<style scoped></style>
